export enum LmObjektstatus {
  Planerad = 'Planerad',
  GallandeUnderUtredning = 'Gällande under utredning',
  Gallande = 'Gällande',
  Avregistrerad = 'Avregistrerad'
}
